import { useState } from "react";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@altimateai/lego";

import CreateTicketModal from "./CreateTicketModal";
import AssignToDatamateModal from "./AssignToDatamateModal";
import { useNavigate } from "react-router-dom";
import { IconCode, IconFileCode2 } from "@tabler/icons-react";
import { OpportunityDetails } from "@/components/closingLoop/types";
import { RobotIcon } from "@/assets/icons";

interface ActionsDropdownProps {
  opportunity: OpportunityDetails;
  integrationIds?: string[];
}

enum Dialog {
  TICKET = "ticket",
  DATAMATE = "datamate",
}

type ModalType = "ticket" | "datamate" | null;

export default function ActionsDropdown({ opportunity, integrationIds }: ActionsDropdownProps) {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleOpenInPlayground = (message?: string, selectedDatamate?: string) => {
    if (message && selectedDatamate) {
      // If content is provided, navigate to playground with that content
      navigate(`/studio`, { state: { message, selectedDatamate }, replace: true });
      return;
    }
  };

  return (
    <>
      <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant={"outline"}
            size={"sm"}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <RobotIcon className="al-text-brand" />
            <span className="al-text-sm">Actions</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="al-w-56">
          <DropdownMenuItem
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              setOpenModal(Dialog.TICKET);
            }}
            className="al-cursor-pointer"
          >
            <IconFileCode2 />
            <span>Create Ticket</span>
          </DropdownMenuItem>

          <DropdownMenuItem
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              setOpenModal(Dialog.DATAMATE);
            }}
            className="al-cursor-pointer"
          >
            <IconCode />
            <span>Open in IDE</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Modals */}
      {openModal === Dialog.TICKET && (
        <CreateTicketModal
          isOpen={true}
          onClose={() => setOpenModal(null)}
          opportunity={opportunity}
          onOpenInPlayground={(message, selectedDatamate) => {
            setOpenModal(null);
            handleOpenInPlayground(message, selectedDatamate);
          }}
        />
      )}

      {openModal === Dialog.DATAMATE && (
        <AssignToDatamateModal
          isOpen={true}
          onClose={() => setOpenModal(null)}
          opportunity={opportunity}
          integrationIds={integrationIds}
        />
      )}
    </>
  );
}
